// import dialogPermission from '../dialogs/dialog_permission';
const paymentAccountsAndLedger = require('../../config.js').configs.paymentAccountsAndLedger;
const transactionForms = require('../../config.js').configs.transactionForms;
const dialogjs =  require('../masters/forms/dialog').dialogjs;
const menuItem = require('../../config.js').configs.menuItem;

export const transactionMixin =  {

    data(){
        return{
            ewayBillDetailSection:JSON.parse(JSON.stringify(require('../../config.js').configs.transactionFields.ewayBillDetailSection)),
            ewayBillDetailFields:JSON.parse(JSON.stringify(require('../../config.js').configs.transactionFields.ewayBillDetailFields)),
            disableAction:false,
            creditAccountLedgerId:"4117faf1-b1d1-4f7f-913a-f1dc489fdb3c",
            onCreditValue:null,
            snackbarOpenFile:false,
            offsetTop:0,
            transactionCount:0,
            confirmationMessage:null,
            confirmationHeader:null,
            confirmationAction:null,
            confirmationActionParam:null,
            snackbarTaxCategory:false,
            selectedAddOn:null
        }
    },

    // components:{
    //     'dialog-permission': dialogPermission,
    // },

    methods: {

        fn_debounceSearch: function(){
             if (this.timeoutid != null){
                clearTimeout(this.timeoutid);
             }

            this.timeoutid = setTimeout(() => { 
                this.fn_searchItem();
            },100);
        },

        fn_getTransactionTitle: function(transactionListId){
            for(let i=0; i<transactionForms.length; i++){
                if(transactionForms[i].id == transactionListId){
                    return transactionForms[i].title;
                }
            }
        },

        fn_viewPartyDetails: function(partyId){
            if(partyId){
                this.$router.push('/masters/accounts/ledgers/items/'+partyId);    
            }
        },

        onScrollTransactionForm (e) {
            this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
        },

        // calling from display view
        fn_checkForItems: function(){
            if(this.displayData && this.displayData.transactionProducts && this.displayData.transactionProducts.length){
                return true;
            }
            else{
                return false;
            }
        },

        fn_previewInvoice: function(fromDisplayView, type, printType, itemObj, printTitle){
            if(localStorage.getItem("template_settings")){
                localStorage.removeItem("template_settings");
            }
            let title = itemObj ? itemObj.toolbarTitle : this.toolbarTitle ? this.toolbarTitle : printTitle;

            let toolbarTitle = title.toLowerCase().replace(/ /g,'');

            let listId = itemObj ? itemObj.transactionListId : this.settings.transactionTypeId;
            let tId = null;
            let template_no = null;

            if(fromDisplayView){
                tId = itemObj ? itemObj.transactionId : this.displayData.transactionId;
                template_no = itemObj ? itemObj.invoiceTemplate : this.displayData.invoiceTemplate;
                if(printType=='st'){
                    template_no = 301
                }
                else if(printType=='bm'){
                    template_no = 302
                }
                // else{
                //     template_no = this.Form.transactionTypeData.transactionTypePrints[0].invoiceTemplate;
                // }
                this.$router.push({path:"/invoice/preview", query:{title: toolbarTitle, listId:listId, tId:tId, template_no:template_no, type:type, printtype:printType}});
            }
            else{
                tId = this.Form.transactionData.transactionId;
                if(printType=='st'){
                    template_no = 301
                }
                else if(printType=='bm'){
                    template_no = 302
                }
                else{
                    template_no = this.Form.transactionTypeData.transactionTypePrints[0].invoiceTemplate;
                }
                this.$router.replace({path:"/invoice/preview", query:{title: toolbarTitle, listId:listId, tId:tId, template_no:template_no, type:type, printtype:printType}});
            }
        },

        fn_cancelTransaction: function(transactionId, transactionListId, type){
            let self = this;
            let filterObject = {};
            filterObject.transactionListId = [transactionListId];
            this.postFilterData('CancelTransaction', transactionId, filterObject, {

                onSuccess: function(response){
                    
                    console.log(response);

                    let status = Number(response);

                    if(type=='form'){
                        self.fn_cleanUp();
                    }
                    else{
                        self.displayData.status = status;
                    }
                    
                    if(status==0){
                        self.showToast("Transaction "+self.displayData.mergeTransactionNumber+ "cancelled");
                    }

                }, 
                onError: function(error){
                  console.log(error);
                  let status = JSON.parse(error);
                    if(status && status.itemsCount){
                        let msg = 'Unable to cancel as this item already in use under [' + status.items.join(', ') + ']';
                        self.showToast(msg);
                    }
                }
            });
        },

        fn_deleteTransaction: function(transactionId, transactionListId, callback){
            let self = this;
            let filterObject = {};
            filterObject.transactionListId = [transactionListId];
            this.postFilterData('deleteTransaction', transactionId, filterObject, {

                onSuccess: function(response){
                    
                    console.log(response);

                    callback(JSON.parse(response));

                }, 
                onError: function(error){
                    console.log(error);
                    let status = JSON.parse(error);
                    if(status && status.itemsCount){
                        let msg = 'Unable to delete as this item already in use under [' + status.items.join(', ') + ']';
                        self.showToast(msg);
                    }
                }
            });
        },

        fn_getPrintData: function(name, transactionId, type, shareObj, tNumber, tDate, transactionListId){
            if(type=='print' || type=='thermal'){
                this.showLoading('Please wait...');
                this.fn_allowPrintData(name, transactionId, type, shareObj, tNumber, tDate, transactionListId);
            }
            else{
                let self = this;
                this.$root.fn_checkStoragePermission(function(){
                    self.showLoading('Please wait...');
                    self.fn_allowPrintData(name, transactionId, type, shareObj, tNumber, tDate, transactionListId);
                })
            }
            
        },

        fn_allowPrintData: function(name, transactionId, type, shareObj, tNumber, tDate, transactionListId){
            var self = this;
            this.getData(name, transactionId, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.printData = JSON.parse(response);

                        // setTimeout(() => {
                        //     if(self.$root.TransactionSettings.fullPagePrint && document.querySelector('.page.receipt_template')){
                        //         document.getElementById('printable').style.display = 'block';
                        //         document.querySelectorAll('.page.receipt_template .spacer-row')[0].style.height  = 0;
                        //         let fullPageElement = document.querySelector('.page.receipt_template');
                        //         // fullPageElement.style.display = 'block';
                        //         // fullPageElement.offsetHeight > 1120 ? fullPageElement.height = 1120 : ''; 
                        //         let heightInMM = fullPageElement.offsetHeight * 0.264583; // convert px to mm
                        //         // document.querySelectorAll('.page.receipt_template .spacer-row')[0].style.height = (297 - heightInMM) + 'mm';
                        //         // let padding = self.$root.TransactionSettings.enableCustomerSignature || document.querySelector('.signatory') ? 55 : 20;
                        //         document.querySelectorAll('.page.receipt_template .spacer-row')[0].style.height = (297 - heightInMM - 20) + 'mm';
                        //         document.getElementById('printable').style.display = 'none';
                        //     }
                        // }, 100);

                        // if(self.printData.transactionDetails && self.printData.transactionDetails.transactionItems && self.printData.transactionDetails.transactionItems.length){
                        //     self.fn_removeZeroTaxAddons();
                        // }
                        
                        setTimeout(function(){
                            if(self.printData.templateSettings && self.printData.templateSettings.invoiceTemplate == 101){
                                self.$refs['ref_printTemplate'].fn_init(()=>{

                                    setTimeout(() => {
                                        if(self.$root.TransactionSettings.fullPagePrint && document.querySelector('.page.receipt_template')){
                                            document.getElementById('printable').style.display = 'block';
                                            let fullPageElement = document.querySelector('.page.receipt_template');
                                            let heightInMM = fullPageElement.offsetHeight * 0.264583; // convert px to mm
                                            document.querySelectorAll('.page.receipt_template .spacer-row')[0].style.height = (297 - heightInMM - 20) + 'mm';
                                            document.getElementById('printable').style.display = 'none';
                                        }

                                        self.hideLoading();
                                        if(type=='print'){
                                            self.fn_printInvoice(tNumber, tDate, transactionListId);
                                        }
                                        else if(type=='pdf'){
                                            self.fn_exportToPdf(shareObj, tNumber, transactionListId);
                                        }
                                        else if(type=='thermal'){
                                            self.$refs['ref_printTemplate'].fn_compressBusinessLogo();
                                        }
                                    }, 500);
                                });
                            }
                            else{
                                if(self.$root.TransactionSettings.fullPagePrint && name != 'StockTransferInvoiceData' && name != 'BOMInvoiceData'){
                                    self.$refs['ref_previewTemplate'].fn_init(null, null, ()=>{
                                        // self.hideLoading();
                                        console.log('ref_previewTemplate loaded');

                                        self.$refs['ref_printTemplate'].fn_init(null, null, ()=>{
                                            self.hideLoading();
                                            if(type=='print'){
                                                self.fn_printInvoice(tNumber, tDate, transactionListId);
                                            }
                                            else if(type=='pdf'){
                                                setTimeout(() => {
                                                    self.fn_exportToPdf(shareObj, tNumber, transactionListId);
                                                }, 1000);
                                            }
                                            else if(type=='thermal'){
                                                self.$refs['ref_printTemplate'].fn_compressBusinessLogo();
                                            }
                                        });
                                    });
                                }
                                else{
                                    self.$refs['ref_printTemplate'].fn_init(null, null, ()=>{
                                        self.hideLoading();
                                        if(type=='print'){
                                            self.fn_printInvoice(tNumber, tDate, transactionListId);
                                        }
                                        else if(type=='pdf'){
                                            self.fn_exportToPdf(shareObj, tNumber, transactionListId);
                                        }
                                        else if(type=='thermal'){
                                            self.$refs['ref_printTemplate'].fn_compressBusinessLogo();
                                        }
                                    });
                                }
                            }
                            
                        },1000);

                        // setTimeout(function(){
                        //     self.hideLoading();
                        //     if(type=='print'){
                        //         self.fn_printInvoice(tNumber, tDate, transactionListId);
                        //     }
                        //     else if(type=='pdf'){
                        //         self.fn_exportToPdf(shareObj, tNumber, transactionListId);
                        //     }
                        // },2000);

                    }, 
                    onError: function(error){
                        console.log(error);           
                    }
                }
            );
        },

        fn_removeZeroTaxAddons: function(){
            for(let i=0; i<this.printData.transactionDetails.transactionItems.length; i++){
                let item = this.printData.transactionDetails.transactionItems[i];
                item.cols.addOns = item.cols.addOns.filter(addOnsItem => {
                    // return addOnsItem.isGst && addOnsItem.percentage != 0;
                    return addOnsItem.percentage != 0;
                })
            }
        },

        fn_printInvoice: function(tNumber, tDate, transactionListId){

            let transactionNumber = tNumber ? tNumber : this.displayData.mergeTransactionNumber ? this.displayData.mergeTransactionNumber : '';

            let listId = transactionListId ? transactionListId : this.displayData.transactionListId;

            let transactionId = this.displayData && this.displayData.transactionId ? this.displayData.transactionId : null;

            let title = null;
            if(listId==10003){
                title = "Invoice";
            }
            else{
                title = this.fn_getTransactionTitle(listId);
            }

            // let transactionTypeFormName = typeFormName ? typeFormName : this.displayData.transactionTypeFormName;
            
            // if(!transactionTypeFormName){
            //     transactionTypeFormName = this.toolbarTitle;
            // }
            // if(transactionTypeFormName){
            //     transactionTypeFormName = typeFormName ? typeFormName : this.displayData.transactionTypeFormName;
            // }
            // else{
            //     transactionTypeFormName = this.toolbarTitle;
            // }
            // if(transactionTypeFormName.toLowerCase() == "itc not eligible"){
            //     transactionTypeFormName = "Expense";
            // }

            // if(transactionTypeFormName == "Retail Invoice" || transactionTypeFormName == "Wholesale Invoice" || transactionTypeFormName == "Export Invoice" || transactionTypeFormName ==  "Stock Transfer"){
            //     transactionTypeFormName = "Invoice";
            // }

            let old = document.getElementById('dynamic-page-size');
    		if (old) old.remove();

            // setting up page size dynamically
            if(this.$root.TransactionSettings.fullPagePrint){
                this.$root.fn_settingUpPrintPageSize();
            }

            let fileName = title.replace(/ /g,'') + '-' + transactionNumber.replace(/\//g,'') + '_' + this.$root.fn_getCurrentDateTimeString();

            let printPageSize = this.$root.TransactionSettings.printPageSize ? this.$root.TransactionSettings.printPageSize : 'A4';
            let pageOrientation = this.$root.TransactionSettings.invoiceOrientation && !this.$root.TransactionSettings.fullPagePrint ? 'true' : 'false';
            // AndroidRoutingTest.print(fileName, printPageSize, pageOrientation);
            this.androidPrint(fileName, printPageSize, pageOrientation);
            // let props = {
            //     fileName:fileName,
            //     pageFormat:printPageSize,
            //     printMode:pageOrientation,
            //     topMargin:this.$root.TransactionSettings.invoiceTopMargin ? this.$root.TransactionSettings.invoiceTopMargin : 10,
            //     bottomMargin:this.$root.TransactionSettings.invoiceBottomMargin ? this.$root.TransactionSettings.invoiceBottomMargin : 10
            // }
            // this.androidPrint(props);

            let postObj = {
                "eventName": 'print_transaction',
                "eventData":[
                    {"eventKey":"BusinessId","eventValue":this.$root.CurrentBusiness.BusinessID},
                    {"eventKey":"TransactionId","eventValue":transactionId},
                    {"eventKey":"TransactionNumber","eventValue":transactionNumber},
                    {"eventKey":"TransactionForm","eventValue":title},
                ]
                // "eventName": 'print_'+title,
                // "eventData":[
                //     {"eventKey":"print_details","eventValue":title+'_#'+transactionNumber + ' from ' + this.$root.CurrentBusiness.BusinessName}
                // ]
            }
            this.$root.fn_postMetrics(postObj);
        },

        fn_exportToPdf: function(shareObj, tNumber, transactionListId){
            let self = this;
            // let downloadTime = new Date(this.displayData.transactionDate).getTime();
            // let downloadTime = new Date();
            let transactionNumber = tNumber ? tNumber : this.displayData.mergeTransactionNumber ? this.displayData.mergeTransactionNumber : '';

            let transactionId = this.displayData && this.displayData.transactionId ? this.displayData.transactionId : null;

            // let transactionTypeFormName = typeFormName ? typeFormName : this.displayData.transactionTypeFormName;

            // if(!transactionTypeFormName){
            //     transactionTypeFormName = this.toolbarTitle;
            // }

            // if(transactionTypeFormName.toLowerCase() == "itc not eligible"){
            //     transactionTypeFormName = "Expense";
            // }

            // if(transactionTypeFormName == "Retail Invoice" || transactionTypeFormName == "Wholesale Invoice" || transactionTypeFormName == "Export Invoice" || transactionTypeFormName ==  "Stock Transfer"){
            //     transactionTypeFormName = "Invoice";
            // }

            let listId = transactionListId ? transactionListId : this.displayData.transactionListId;

            let title = null;
            if(listId==10003){
                title = "Invoice";
            }
            else{
                title = this.fn_getTransactionTitle(listId);
            }

            // if(transactionTypeFormName){
            //     transactionTypeFormName = this.displayData.transactionTypeFormName;
            // }
            // else{
            //     transactionTypeFormName = this.toolbarTitle;
            // }

            let fileName = title.replace(/ /g,'') + '-' + transactionNumber.replace(/\//g,'') + '_' + this.$root.fn_getCurrentDateTimeString();
            // let fileName = 'invoice_'+transactionNumber + downloadTime.getTime();
            let pageOrientation = this.$root.TransactionSettings.invoiceOrientation && !this.$root.TransactionSettings.fullPagePrint ? 'true' : 'false';
            this.exportToPdf(fileName+'.pdf', pageOrientation,{

              onSuccess: function(response){    
                    console.log(response);
                    if(shareObj != undefined){
                        self.$root.fn_share(shareObj)
                    }
                    else{
                        self.showToast(title + ' downloaded');
                        self.snackbarOpenFile = true;

                        let postObj = {
                            "eventName": 'download_transaction',
                            "eventData":[
                                {"eventKey":"BusinessId","eventValue":self.$root.CurrentBusiness.BusinessID},
                                {"eventKey":"TransactionId","eventValue":transactionId},
                                {"eventKey":"TransactionNumber","eventValue":transactionNumber}
                                // {"eventKey":"TransactionForm","eventValue":transactionForm},
                            ]
                            // "eventName": 'download_'+title,
                            // "eventData":[
                            //     {"eventKey":"download_details","eventValue":title+'_#'+transactionNumber + ' from ' + self.$root.CurrentBusiness.BusinessName}
                            // ]
                        }
                        self.$root.fn_postMetrics(postObj);
                    }
              }, 
              onError: function(error){
                  console.log(error);
                  self.showToast(title + ' download failed');
              }
            });
        },

        // fn_share: function(shareObj){
        //     var self = this;
        //     this.postData('Share', shareObj, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //             },
        //             onError: function(error){
        //                 console.log(error);
        //                 self.showToast('Unable to share at this time');
        //             }
        //         }
        //     );
        // },

        fn_getFiscalYear: function(date){
            let dateObj = date ? new Date(date) : new Date();
            let month = dateObj.getMonth() + 1;
            let year = dateObj.getFullYear();
            let fy = month > 3 ? year : year-1;
            return fy
        },

        /*=========================== Opening date mixins (using in opening ledger and opening stock) ===========================*/

        // fn_checkOpening: function(openingStockListId, openingLedgerListId){
        //     let self = this;
        //     this.getData('CheckOpening', this.$root.CurrentBusiness.BusinessID, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 let openingDate = null;
        //                 if(response && response!='null'){
        //                     openingDate = JSON.parse(response);
        //                 }
                        
        //                 if(openingDate){
        //                     self.openingDate = new Date(openingDate);
        //                 }
        //                 else{
        //                     self.fn_getFirstTransactionDate(openingDate, openingStockListId, openingLedgerListId);    
        //                 }
        //                 // openingDate ? self.openingDate = new Date(openingDate) : '';
        //                 // self.fn_getFirstTransactionDate(openingDate, openingStockListId, openingLedgerListId);
        //             }, 
        //             onError: function(error){
        //                 console.log(error);
        //             }
        //         }
        //     );
        // },

        // fn_getFirstTransactionDate: function(openingDate, openingStockListId, openingLedgerListId){
        //     let self = this;
        //     let filterObject = {};
        //     filterObject.transactionListId = [openingStockListId, openingLedgerListId];
        //     this.getFilterData('FirstTransactionDate', null, filterObject,
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 let ftd = JSON.parse(response);
        //                 let maxDate = null;

        //                 if(!ftd){
        //                     //Calculation of max date fy
        //                     let currentDate = new Date();
        //                     let currentMonth = currentDate.getMonth() + 1;
        //                     let currentYear = currentDate.getFullYear();

        //                     let year = null
        //                     year = currentMonth < 3 ? currentYear : currentYear+1;

        //                     maxDate = new Date(year+"-03-31");
        //                 }
        //                 else{
        //                     maxDate = new Date(ftd);
        //                 }

        //                 console.log(maxDate);

        //                 let year = self.$moment(maxDate).format('YYYY');
        //                 let month = self.$moment(maxDate).format('MM');
        //                 let day = self.$moment(maxDate).format('DD');

        //                 self.maxOpeningDate = year+"-"+month+"-"+day;
        //                 self.fn_calculateOpeningDate(ftd)
                        
        //             },
        //             onError: function(error){
        //                 console.log(error);
        //             }
        //         }
        //     );
        // },

        // fn_calculateOpeningDate: function(ftd){

        //     let openingLedgerYear = null;

        //     let firstTransactionFY = this.fn_getFiscalYear(ftd);
        //     let currentFY = this.fn_getFiscalYear();

        //     if(firstTransactionFY <= currentFY){
        //         openingLedgerYear = firstTransactionFY;
        //     }
        //     else{
        //         openingLedgerYear = firstTransactionFY - 1;
        //     }

        //     let defaultOpeningDate = new Date(openingLedgerYear+"-04-01");
        //     // !this.openingDate ? this.openingDate = defaultOpeningDate : '';

        //     //saving default opening date 1st apr if no opening date found
        //     if(!this.openingDate){
        //         this.openingDate = defaultOpeningDate;
        //         this.fn_saveOpeningDate()
        //     }
            
        //     let year = this.$moment(defaultOpeningDate).format('YYYY');
        //     let month = this.$moment(defaultOpeningDate).format('MM');
        //     let day = this.$moment(defaultOpeningDate).format('DD');

        //     this.minDate = year+"-"+month+"-"+day;
        // },

        fn_changeOpeningDate: function(){
            this.fn_closeDialog();
            let self = this;
            setTimeout(function(){
                self.askToDiscard = false;
                // self.$router.push({path:"/settings/openingdate", query:{goback:1}});
                self.$router.push({path:"/settings/openingdate"});
            },300);
        },

        // used to change opening date from opening ledger/stock
        // fn_openDatePickerOpening: function () {
        //     this.askToDiscard = false;
        //     this.fn_closeDialog();
        //     this.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePickerOpening');
        // },

        // fn_updateDateOpening: function(value){
        //     this.openingDate = value;
        //     console.log(this.openingDate);
        //     this.fn_saveOpeningDate();
        // },

        // fn_saveOpeningDate: function(){
        //     var self = this;

        //     let postObj = {};

        //     //subtracted 1 day from opening date as we are adding opening one day less than user selected opening date

        //     // postObj.openingDate = new Date(JSON.parse(JSON.stringify(this.openingDate)));
        //     // postObj.openingDate.setDate(postObj.openingDate.getDate()-1);
        //     postObj.openingDate = new Date(JSON.parse(JSON.stringify(this.openingDate)));
        //     postObj.BusinessID = this.$root.CurrentBusiness.BusinessID;

        //     let od = new Date(JSON.parse(JSON.stringify(this.openingDate)));
        //     od.setDate(od.getDate()-1);
        //     postObj.transactionDate = new Date(od);
        //     postObj.transactionListId = [40001, 40003];

        //     this.postData('OpeningDate', postObj, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 self.fn_setMinTransactionDate();
        //                 self.fn_closeDialog();
        //                 self.showToast('Opening date saved');
        //             },
        //             onError: function(error){
        //                 console.log(error);
        //                 self.showToast('Something went wrong. Try again!.');
        //             }
        //         }
        //     );
        // },

        // fn_setMinTransactionDate: function(){
        //     let year = this.$moment(this.openingDate).format('YYYY');
        //     let month = this.$moment(this.openingDate).format('MM');
        //     let day = this.$moment(this.openingDate).format('DD');

        //     this.$root.minDateSelection = year+"-"+month+"-"+day;
        // },

        /*=========================== End of Opening date mixins (using in opening ledger and opening stock) ===========================*/

        fn_checkTransactionCount: function(callback){
            let self = this;
            this.getData('TransactionCount', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        let count = Number(response);
                        self.transactionCount = Number(response);
                        callback ? callback(count) : '';
                        // setTimeout(function(){
                        //     count >= 10 ? self.fn_gotoSetupDrive() : '';
                        // },1000);
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_openDialogDriveSetup: function(){
            this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDriveAlert');
            setTimeout(() => {
                this.fn_removeDraft(this.draftStorageId);
            }, 500);
        },

        fn_gotoSetupDrive: function(){
            // if(!navigator.onLine){
            //     this.showToast("Internet not available");
            //     return;
            // }
            
            // this.fn_closeDialog();
            let self = this;
            this.fn_removeDraft(this.draftStorageId, function(){
                self.$router.push({path:"/registration/business/setupdrive"});
            });
            // this.askToDiscard = false;
            
        },

        fn_setupDrive: function(){
            this.backButtonPress = false;
            // this.$router.push({path:"/registration/business/setupdrive", query:{goback:1, isdialogopen:1}});
            this.$router.push({path:"/registration/business/setupdrive", query:{goback:1, isdialogopen:1, t_count:this.transactionCount}});
        },

        fn_openTransacionTypeList_onFormLoad: function(){
            let self = this;
            if(!this.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive") && !localStorage.getItem('newItem')){
                this.fn_checkTransactionCount(function(transactionCount){
                    if(transactionCount < 10){
                        self.fn_openTransactionTypeList();
                    } 
                })  
            }
            else{
                this.fn_openTransactionTypeList();
            }
        },

        fn_openParties_onFormLoad: function(openParty, fnPartyDialog){
            let self = this;
            if(openParty && !this.$route.query.dt && !localStorage.getItem('newItem')){
                // if(!this.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive")){
                    // local storage SetDataDrive is using to jump on setup backup drive page so we are opening party dialog only incase of local storage SetDataDrive does not exist
                // if(!this.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive")){
                //     this.fn_checkTransactionCount(function(transactionCount){
                //         if(transactionCount < 10){
                //             setTimeout(function(){
                //                 fnPartyDialog();
                //             },300);
                //         } 
                //     })  
                // }
                // else{
                //     setTimeout(function(){
                //         fnPartyDialog();
                //     },300);
                // }
                setTimeout(function(){
                    fnPartyDialog();
                },300);
            }

        },

        // fn_openPermissionDialog: function(permissionType){
        //     this.$root.permissionType = permissionType;
        //     this.$refs['ref_dialogPermission'].dialog_permission = true;
        // },

        fn_uploadFiles: function(){
            var self = this;
            let postObj = {};
            postObj.fileExtensions = ['PDF','DOC','DOCX','TEXT','XLX','XLSX','CSV'];
            postObj.imageExtension = ['JPG','JPEG','PNG'];
            // this.showLoading('Uploading...');
            this.postData('SelectLocalDocument', postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        let documentObj = JSON.parse(response);
                        documentObj.documentId = self.guid();
                        documentObj.isNew = 1;
                        self.Form.attachments.push(JSON.parse(JSON.stringify(documentObj)));
                        setTimeout(function(){
                            self.$vuetify.goTo('#doc_'+documentObj.documentId, self.scrollOptions);
                        },300);
                        // self.hideLoading();
                    },
                    onError: function(error){
                        console.log(error);
                        if(error && error.toLowerCase() == "request cancel"){
                          console.log('request cancel');
                        }
                        else if(error == "Not Supported"){
                          self.showToast("File not supported");
                        }
                        else if(error == "file size exceeds"){
                            self.showToast("File size exceeds");   
                        }
                        else{
                          self.showToast("Something went wrong. Try again");
                        }
                        // self.hideLoading();
                    }
                }
            );
        },

        fn_captureImage: function(){
            let self = this;
            this.getData('CaptureImage', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        let documentObj = JSON.parse(response);
                        documentObj.documentId = self.guid();
                        documentObj.isNew = 1;
                        self.Form.attachments.push(JSON.parse(JSON.stringify(documentObj)));
                        setTimeout(function(){
                            self.$vuetify.goTo('#doc_'+documentObj.documentId, self.scrollOptions);
                        },300);
                    }, 
                    onError: function(error){
                        console.log(error);
                        if(error && error.toLowerCase() == "request cancel"){
                          console.log('request cancel');
                        }
                        else if(error == "file size exceeds"){
                            self.showToast("File size exceeds");   
                        }
                        else{
                            self.showToast("Something went wrong. Try again");    
                        }
                    }
                }
            );
        },

        fn_removeAttachment: function(item){
            if(item.isNew){
                let itemIndex = this.Form.attachments.findIndex(file => file.documentId==item.documentId);
                this.Form.attachments.splice(itemIndex, 1);
            }
            else{
                item.uploadStatus = 2;
            }
        },

        fn_checkFileExist: function(item){
            let self = this;
            this.getData('CheckFileExists', item.documentId, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        if(response == 'file exists'){
                            self.fn_openFile(item.documentId);
                        }
                        else{
                            if(item.driveFileId){
                                if(!navigator.onLine){
                                    this.showToast('Internet not available');
                                }
                                else{
                                    self.fn_downloadFile(item);
                                }
                            }
                            else{
                                self.showToast("File upload in progress. Please try after sometime");
                            }
                        }
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.showToast("Something went wrong");
                    }
                }
            );
        },

        fn_openFile: function(documentId){
            this.getFilterData('OpenDocumentFile', documentId, null,
                {
                    onSuccess: function(response){
                        console.log(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_downloadFile: function(item){
            let self = this;

            let filterObject = {};
            //draft last modifiedDate
            filterObject.documentDetails = [item];
            filterObject.businessId = this.$root.CurrentBusiness.BusinessID;
            // this.showLoading('Downloading File...');
            // this.$refs['ref_dialogLoading'].dialog_loading = true;
            this.$refs['ref_dialogLoading'].openDialogWeb();
            this.getFilterData('RestoreDocumentFile', null, filterObject, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        // self.hideLoading();
                        // self.$refs['ref_dialogLoading'].dialog_loading = false;
                        // self.$refs['ref_dialogLoading'].closeDialogWeb();
                        self.$refs['ref_dialogLoading'].closeDialogWeb();
                        console.log("File Downloaded");
                        self.showToast("File Downloaded");
                        self.fn_openFile(item.documentId);
                    }, 
                    onError: function(error){
                        console.log(error);
                        // self.hideLoading();
                        self.$refs['ref_dialogLoading'].dialog_loading = false;
                        self.showToast("Something went wrong. Try again");
                    }
                }
            );
        },

        // ================================== Payment mode functions ================================== //

        fn_openDialog_PaymentOptions: function(){
            let self = this;
            if(this.Form.paymentOptions.length){
                for(let i=0; i<this.Form.paymentOptions.length; i++){
                    this.Form.paymentGroups.forEach(function(group){
                        group.accountLedgers.forEach(function(ledger){
                            if(ledger.accountLedgerId == self.Form.paymentOptions[i].accountLedgerId){
                                self.$set(ledger, 'selected', true);
                                self.$set(ledger, 'amount', self.Form.paymentOptions[i].amount);
                                self.$set(ledger, 'refNumber', self.Form.paymentOptions[i].refNumber);
                            }
                        });
                    });

                    if(self.Form.dutiesAndTaxesLedgers && self.Form.dutiesAndTaxesLedgers.length){
                        self.Form.dutiesAndTaxesLedgers.forEach(function(ledger){
                            if(ledger.accountLedgerId == self.Form.paymentOptions[i].accountLedgerId){
                                self.$set(ledger, 'selected', true);
                                self.$set(ledger, 'amount', self.Form.paymentOptions[i].amount);
                                self.$set(ledger, 'refNumber', self.Form.paymentOptions[i].refNumber);
                            }
                        });
                    }

                    if(self.Form.otherLedgers && self.Form.otherLedgers.length){
                        self.Form.otherLedgers.forEach(function(ledger){
                            if(ledger.accountLedgerId == self.Form.paymentOptions[i].accountLedgerId){
                                self.$set(ledger, 'selected', true);
                                self.$set(ledger, 'amount', self.Form.paymentOptions[i].amount);
                                self.$set(ledger, 'refNumber', self.Form.paymentOptions[i].refNumber);
                            }
                        });
                    }
                    
                }
            }
            this.fn_openDialogWeb('web', 'PaymentOptions', 'ref_dialogPaymentOptions')

            setTimeout(function(){
                let formElementDialog = document.getElementsByClassName("form-element-dialog");
                if(formElementDialog && formElementDialog.length){
                    formElementDialog[0].addEventListener("submit", function(e){
                        e.preventDefault();
                    });     
                }
            },500);
        },

        // fn_getPaymentGroups: function () {
        //     let filterObject = {};
        //     filterObject.accountGroups = [paymentAccountsAndLedger.groups.cashInHand, paymentAccountsAndLedger.groups.bank, paymentAccountsAndLedger.groups.card, paymentAccountsAndLedger.groups.wallet];

        //     let self = this;
        //     this.getFilterData('PaymentGroups', null, filterObject, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 self.Form.paymentGroups = JSON.parse(response);

        //                 let onCreditObj = {"accountGroupId":"creditAccountGroup","accountGroupName":null,"accountLedgers":[{"accountLedgerId":self.creditAccountLedgerId,"accountLedgerName":"On Credit"}]};

        //                 self.Form.paymentGroups.unshift(onCreditObj);

        //                 self.Form.paymentGroups.forEach(function(group){
        //                     group.accountLedgers.forEach(function(ledger){
        //                         self.$set(ledger, 'selected', false);
        //                         self.$set(ledger, 'amount', null);
        //                     });
        //                 });

        //                 // assigning payment ledger id incase of paymentLedgerId undefined or !split payment for both cases new/edit
        //                 if(!self.Form.paymentLedgerId && !self.Form.splitPayment){
        //                     self.Form.paymentLedgerId = onCreditObj.accountLedgers[0].accountLedgerId;  
        //                 }
                        

        //             }, 
        //             onError: function(error){
        //               console.log(error);
        //             }
        //         }
        //     );
        // },

        fn_getPaymentGroups: function (assignRemember) {
            let filterObject = {};
            filterObject.accountGroups = [paymentAccountsAndLedger.groups.cashInHand, paymentAccountsAndLedger.groups.bank, paymentAccountsAndLedger.groups.card, paymentAccountsAndLedger.groups.wallet];

            let self = this;
            this.getFilterData('PaymentGroups', null, filterObject, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        // self.Form.paymentGroups = JSON.parse(response);

                        // let onCreditObj = {"accountGroupId":"creditAccountGroup","accountGroupName":null,"accountLedgers":[{"accountLedgerId":self.creditAccountLedgerId,"accountLedgerName":"On Credit"}]};

                        // self.Form.paymentGroups.unshift(onCreditObj);

                        let groups = JSON.parse(response);

                        groups.forEach(function(group){

                            // assigning order number to groups for sorting
                            if(group.accountGroupId == paymentAccountsAndLedger.groups.cashInHand){
                                group.orderNumber = 1;
                            }
                            else if(group.accountGroupId == paymentAccountsAndLedger.groups.bank){
                                group.orderNumber = 2;
                            }
                            else if(group.accountGroupId == paymentAccountsAndLedger.groups.card){
                                group.orderNumber = 3;
                            }
                            else if(group.accountGroupId == paymentAccountsAndLedger.groups.wallet){
                                group.orderNumber = 4;
                            }
                            
                            group.accountLedgers.forEach(function(ledger){
                                !ledger.selected ? self.$set(ledger, 'selected', false) : '';
                                !ledger.amount ? self.$set(ledger, 'amount', null) : '';
                                !ledger.refNumber ? self.$set(ledger, 'refNumber', null) : '';
                            });
                        });

                        // sorting groups
                        groups.sort(function(a, b){
                            return a.orderNumber - b.orderNumber;
                        });

                        let onCreditObj = {"accountGroupId":"creditAccountGroup","accountGroupName":null,"accountLedgers":[{"accountLedgerId":self.creditAccountLedgerId,"accountLedgerName":"On Credit"}]};

                        // if(!self.Form.paymentGroups){
                        if(!self.Form.paymentGroups || !self.Form.paymentGroupIndex){
                            self.Form.paymentGroups = JSON.parse(JSON.stringify(groups));
                            self.Form.paymentGroups.unshift(onCreditObj);
                        }
                        else{
                            let newAccountLedger = null;
                            let groupIndex = null;

                            let oldLedgers = self.Form.paymentGroups[self.Form.paymentGroupIndex].accountLedgers;
                            groups.unshift(onCreditObj);
                            let newLedgers = groups[self.Form.paymentGroupIndex].accountLedgers;

                            var res = newLedgers.filter(item1 => !oldLedgers.some(item2 => (item2.accountLedgerId === item1.accountLedgerId)));

                            console.log(res);

                            if(self.Form.splitPayment){
                                res[0].selected = true;
                                self.$refs['ref_dialogPaymentOptions'].toggleAmount(res[0]);
                            }
                            else{
                                self.Form.paymentLedgerId = res[0].accountLedgerId;
                            }

                            self.Form.paymentGroups[self.Form.paymentGroupIndex].accountLedgers.push(res[0]);

                        }

                        // assigning payment ledger id incase of paymentLedgerId undefined or !split payment for both cases new/edit
                        if(!self.Form.paymentLedgerId && !self.Form.splitPayment){
                            self.Form.paymentLedgerId = onCreditObj.accountLedgers[0].accountLedgerId;  
                        }

                        // assigning last remember payment ledger id in case of new form
                        if(self.Form.isNew && assignRemember && !self.Form.isCashTransaction){
                           self.fn_assignLastPaymentId();
                        }
                        

                    }, 
                    onError: function(error){
                      console.log(error);
                    }
                }
            );
        },

        fn_assignLastPaymentId: function(){
            this.$root.fn_getLocalItem('lastpaymentledgerid', response=>{
                let data = JSON.parse(response);

                if(data && data.LocalValue){
                    if(this.$root.TransactionSettings.defaultPaymentMode && this.$root.TransactionSettings.defaultPaymentMode != 1){
                        if(this.$root.TransactionSettings.defaultPaymentMode == 2){
                            this.Form.paymentLedgerId = paymentAccountsAndLedger.ledgers.cash;
                        }
                        else if(this.$root.TransactionSettings.defaultPaymentMode == 3){
                            this.Form.paymentLedgerId = this.creditAccountLedgerId;
                        }
                    }
                    else{
                        this.Form.paymentLedgerId = data.LocalValue;
                    }

                    //set to default option on credit in case of credit note 
                    if(this.toolbarTitle == 'Credit Note'){
                        this.Form.paymentLedgerId = this.creditAccountLedgerId;
                    }
                }
            })
        },

        fn_paymentAccountName: function(accountId){
            if(this.Form.paymentGroups && this.Form.paymentGroups.length){
                for(let i=0; i<this.Form.paymentGroups.length; i++){
                    for(let j=0; j<this.Form.paymentGroups[i].accountLedgers.length; j++){
                        if(this.Form.paymentGroups[i].accountLedgers[j].accountLedgerId == accountId){
                            return this.Form.paymentGroups[i].accountLedgers[j].accountLedgerName;
                        }
                    }   
                }
            }
        },

        savePaymentOptions: function(paymentLedgerId){

            this.Form.paymentOptions = [];
            let groups = JSON.parse(JSON.stringify(this.Form.paymentGroups));

            for(let i=0; i<groups.length; i++){
                for(let j=0; j<groups[i].accountLedgers.length; j++){

                    let ledger = {};
                    ledger.accountLedgerId = groups[i].accountLedgers[j].accountLedgerId;
                    ledger.accountLedgerName = groups[i].accountLedgers[j].accountLedgerName;
                    ledger.amount = groups[i].accountLedgers[j].amount;
                    ledger.refNumber = groups[i].accountLedgers[j].refNumber;

                    if(this.Form.splitPayment){
                        if(groups[i].accountLedgers[j].amount){
                            // let ledger = {};
                            // ledger.accountLedgerId = groups[i].accountLedgers[j].accountLedgerId;
                            // ledger.accountLedgerName = groups[i].accountLedgers[j].accountLedgerName;
                            // ledger.amount = groups[i].accountLedgers[j].amount;
                            // ledger.refNumber = groups[i].accountLedgers[j].refNumber;
                            this.Form.paymentOptions.push(ledger);
                        }
                    }
                    else{
                        if(groups[i].accountLedgers[j].accountLedgerId  == paymentLedgerId){
                            this.Form.paymentLedgerId = paymentLedgerId;
                            break;
                        }
                    }
                    
                }   
            }
            
        },

        fn_generatePaymentEntries: function(ledgerAccounts, transactionLedgers){

            let amountType = null;

            if(this.settings.transactionTypeId == 10003 || this.settings.transactionTypeId == 10004){
                amountType = 1;
            }
            else{
                amountType = 0;
            }

            if(!this.Form.splitPayment){
                //Entries for ledger accounts
                let paymentLedgerObj = {};
                // paymentLedgerObj.amountType = 1;//debit
                paymentLedgerObj.amountType = amountType;//debit
                if(this.Form.paymentLedgerId == this.creditAccountLedgerId){
                    paymentLedgerObj.accountId = this.Form.partyId;
                    // saving on credit amount to transaction table for reporting
                    this.onCreditValue = this.roundedAmount;
                }
                else{
                    paymentLedgerObj.accountId = this.Form.paymentLedgerId;
                    paymentLedgerObj.subAccountId = this.Form.partyId;
                    // saving on credit amount to transaction table for reporting
                    this.onCreditValue = null;
                }
                // paymentLedgerObj.accountId = this.Form.paymentLedgerId;
                // paymentLedgerObj.subAccountId = this.Form.partyId;
                paymentLedgerObj.amount = amountType ? this.roundedAmount : -this.roundedAmount;
                let paymentLedger = this.fn_bindAndReturnSimilarValues(paymentLedgerObj);
                ledgerAccounts.push(paymentLedger);

                //Entries for transaction ledgers
                let tlObj = {};
                tlObj.transactionLedgerId = this.guid();
                tlObj.accountLedgerId = this.Form.paymentLedgerId;
                tlObj.orderNumber = transactionLedgers.length + 1;
                tlObj.amount = this.roundedAmount;
                // tlObj.amountType = 1;
                tlObj.amountType = amountType;
                tlObj.transactionListId = this.Form.transactionData.transactionListId;
                transactionLedgers.push(tlObj);

                // saving on credit amount to transaction table for reporting
                // this.onCreditValue = null;

                // saving payment ledger id to remember for next time"}
                this.$root.fn_saveLocalItem({LocalKey:'lastpaymentledgerid',LocalValue:this.Form.paymentLedgerId});
            }
            else{
                for(let i=0; i<this.Form.paymentOptions.length; i++){
                    //Entries for ledger accounts
                    let paymentLedgerObj = {};
                    // paymentLedgerObj.amountType = 1;//debit
                    paymentLedgerObj.amountType = amountType;//debit
                    if(this.Form.paymentOptions[i].accountLedgerId == this.creditAccountLedgerId){
                        paymentLedgerObj.accountId = this.Form.partyId;
                        // saving on credit amount to transaction table for reporting
                        this.onCreditValue = this.Form.paymentOptions[i].amount;
                        // paymentLedgerObj.amount = this.roundedAmount;
                    }
                    else{
                        paymentLedgerObj.accountId = this.Form.paymentOptions[i].accountLedgerId;
                        paymentLedgerObj.subAccountId = this.Form.partyId;
                        // paymentLedgerObj.amount = this.Form.paymentOptions[i].amount;
                    }
                    // paymentLedgerObj.accountId = this.Form.paymentOptions[i].accountLedgerId;
                    // paymentLedgerObj.subAccountId = this.Form.partyId;
                    paymentLedgerObj.amount = amountType ? this.Form.paymentOptions[i].amount : -this.Form.paymentOptions[i].amount;
                    let paymentLedger = this.fn_bindAndReturnSimilarValues(paymentLedgerObj);
                    ledgerAccounts.push(paymentLedger);

                    //Entries for transaction ledgers
                    let tlObj = {};
                    tlObj.transactionLedgerId = this.guid();
                    tlObj.accountLedgerId = this.Form.paymentOptions[i].accountLedgerId;
                    tlObj.orderNumber = transactionLedgers.length + 1;
                    tlObj.amount = this.Form.paymentOptions[i].amount;
                    // tlObj.amountType = 1;
                    tlObj.amountType = amountType;
                    tlObj.transactionListId = this.Form.transactionData.transactionListId;
                    transactionLedgers.push(tlObj);
                }
            }

        },

        fn_bindAndReturnSimilarValues: function (ledgerObj) {
            ledgerObj.ledgerAccountId = this.guid();
            ledgerObj.transactionListId = this.Form.transactionData.transactionListId;
            ledgerObj.transactionDate = this.Form.transactionData.transactionDate;  
            return ledgerObj;
        },

        // ================================== End of payment mode functions ================================== //

        fn_removeAddOnsOnPlaceOfSupplyChange: function(fixedGstAddOns){
            let tAddOns = false;
            for(let i=0; i<this.Form.transactionAddOns.length; i++){
                let addOn = this.Form.transactionAddOns[i];
                if(this.Form.gstType == "IntraState" && (fixedGstAddOns.UTGST.id == addOn.addOnsId || fixedGstAddOns.IGST.id == addOn.addOnsId)){
                    this.Form.transactionAddOns.splice(i, 1);
                    tAddOns = true;
                    i=-1;
                }
                else if(this.Form.gstType == "UnionTerritory" && (fixedGstAddOns.SGST.id == addOn.addOnsId || fixedGstAddOns.IGST.id == addOn.addOnsId)){
                    this.Form.transactionAddOns.splice(i, 1);
                    tAddOns = true;
                    i=-1;
                }
                else if(this.Form.gstType == "InterState" && (fixedGstAddOns.UTGST.id == addOn.addOnsId || fixedGstAddOns.SGST.id == addOn.addOnsId || fixedGstAddOns.CGST.id == addOn.addOnsId)){
                    this.Form.transactionAddOns.splice(i, 1);
                    tAddOns = true;
                    i=-1;
                }
            }

            if(tAddOns){
                this.showToast("Transaction taxes removed");
            }
        },

        // Update dialog ref on change
        fn_updateDialogRef: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
            let key = ref.substring(0, ref.lastIndexOf('_'));
            let dialogRef = this.$refs[key];

            var checkRefs = setInterval(function(){
                if(dialogRef.$refs.hasOwnProperty(ref)){
                    clearInterval(checkRefs);
                    if(Array.isArray(dialogRef.$refs[ref])){
                        dialogRef.$refs[ref][0].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved, ref);
                    }
                    else{
                        dialogRef.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved, ref);
                    }
                }
            },50);
        },

        // open dialog and set new add ons
        fn_setNewAddOns: function(id, name, isRemoved){
            // if(this.Form.newSelection && !this.$refs['ref_dialogAddOns'].dialog_addons){
            if(localStorage.getItem('newSelection') && !this.$refs['ref_dialogAddOns'].dialog_addons){
                this.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns');
            }
            let self = this;
            setTimeout(() => {
                self.$refs['ref_dialogAddOns'].fn_updateAddOns(id, name, isRemoved);
            }, 300);
        },

        // open dialog and set new product
        // fn_setNewProduct: function(id, name, isRemoved){
        //     if(localStorage.getItem('newSelection') && !this.$refs['ref_dialogProduct'].dialog_product){
        //         this.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct');
        //     }
        //     let self = this;
        //     setTimeout(() => {
        //         self.$refs['ref_dialogProduct'].fn_updateProduct(id, name, isRemoved);
        //     }, 300);
        // },
        fn_setNewProduct: function(id, name, isRemoved){
            // closing product list dialog
            this.fn_closeDialog();
            if(localStorage.getItem('newSelection') && !this.$refs['ref_dialogProduct'].dialog_product){
                // this.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct');
                this.fn_openDialogProductForm();
            }
            setTimeout(() => {
                if(this.$refs['ref_dialogProduct'].dialog_product){
                    this.$refs['ref_dialogProduct'].fn_updateProduct(id, name, isRemoved);
                }
            }, 300);
        },

        fn_openDialogDateConfirmation: function (value) {
            // this.confirmationMessage = "Old transaction date: "+this.$moment(this.Form.transactionData.transactionDate).format('DD-MMM-YYYY')+"<br>New transaction date: "+this.$moment(value).format('DD-MMM-YYYY')+"<br>Do you want to continue?";
            let oldFiscalYear = new Date(this.Form.transactionData.transactionDate).getFullYear();
            let oldFYMonth = new Date(this.Form.transactionData.transactionDate).getMonth() + 1;
            let oldFY = oldFYMonth <= 3 ? oldFiscalYear - 1 : oldFiscalYear;

            let newFiscalYear = new Date(value).getFullYear();
            let newFYMonth = new Date(value).getMonth() + 1;
            let newFY = newFYMonth <= 3 ? newFiscalYear - 1 : newFiscalYear;

            let fyOld = " (FY " + oldFY.toString().substring(2)+"-"+(oldFY+1).toString().substring(2) + ") ";
            let fyNew = " (FY " + newFY.toString().substring(2)+"-"+(newFY+1).toString().substring(2) + ") ";
            // this.confirmationMessage = "A new transaction number will generate as selected date belongs to different Fiscal Year. Do you want to continue?";
            this.confirmationHeader = "Update Transaction Date";
            this.confirmationMessage = fyOld+"<br>Old transaction date: "+this.$moment(this.Form.transactionData.transactionDate).format('DD-MMM-YYYY')+"<br>"+fyNew+"<br>New transaction date: "+this.$moment(value).format('DD-MMM-YYYY')+"<br><br>A new transaction number will assign.<br><br><div font-small style='background-color:#eee;padding:4px 8px'>Note: Transaction number can be updated manually as well.</div><br>Do you want to continue?";
            this.confirmationAction = this.fn_changeDateAndBindTransactionNumber;
            this.confirmationActionParam = value;
            this.fn_openDialogWeb('web', 'Confirmation', 'ref_dialogConfirmation');
        },

        fn_updateTransactionDate: function(value, isNew){
            // let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
            // let openingYear = openingDate.getFullYear();
            // let openingMonth = openingDate.getMonth() + 1;
            // let openingFY = openingMonth <= 3 ? openingYear : openingYear + 1;

            let oldTransactionDate = new Date(this.Form.transactionData.transactionDate);
            let oldTransactionDateYear = oldTransactionDate.getFullYear();
            let oldTransactionDateMonth = oldTransactionDate.getMonth() + 1;
            let oldTransactionDateFY = oldTransactionDateMonth <= 3 ? oldTransactionDateYear : oldTransactionDateYear + 1;

            let tDate = new Date(value);
            let tDateYear = tDate.getFullYear();
            let tDateMonth = tDate.getMonth() + 1;
            let tDateFY = tDateMonth <= 3 ? tDateYear : tDateYear + 1;
            
            // if(isNew || openingFY != tDateFY){
            if(isNew || oldTransactionDateFY != tDateFY){
                // if(openingFY != tDateFY){
                if(oldTransactionDateFY != tDateFY){
                    this.fn_closeDialog();
                    setTimeout(() => {
                        this.fn_openDialogDateConfirmation(value);
                    }, 500);
                }
                else{
                    this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(value);
                    this.fn_bindTransactionNumber();
                }
            }
            else{
                this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(value);
            }

            if(this.$root.appVersion >= 294 && this.Form.items && this.Form.items.length && this.$root.CurrentBusiness.GSTRegistrationStatus==1 && ((this.Form.transactionData.transactionListId != 10004 && this.Form.transactionData.transactionListId != 20004) || !this.fn_hasPendingItems())){
                let tDay = new Date(this.Form.transactionData.transactionDate).getDate();
                let tMonth = new Date(this.Form.transactionData.transactionDate).getMonth() + 1;
                let tYear = new Date(this.Form.transactionData.transactionDate).getFullYear();
                if(
                    (new Date(oldTransactionDateMonth + '/' + oldTransactionDate.getDate() + '/' + oldTransactionDateYear) >= new Date('09/22/2025') &&  new Date(tMonth + '/' + tDay + '/' + tYear) < new Date('09/22/2025'))
                    ||
                    (new Date(oldTransactionDateMonth + '/' + oldTransactionDate.getDate() + '/' + oldTransactionDateYear) < new Date('09/22/2025') &&  new Date(tMonth + '/' + tDay + '/' + tYear) >= new Date('09/22/2025'))
                ){
                    this.snackbarTaxCategory = true;
                }
                else{
                    this.snackbarTaxCategory = false;
                }
            }

            // checking transaction date not equal to current date
            const transactionDate = new Date(this.Form.transactionData.transactionDate).toISOString().split("T")[0];
            const todayDate = new Date().toISOString().split("T")[0];
            if (transactionDate !== todayDate) {
                // console.log("Date is different");
                // Assign current time to the given date
                let now = new Date();
                let currentTimeDate = new Date(this.Form.transactionData.transactionDate).setHours(
                    now.getHours(),
                    now.getMinutes(),
                    now.getSeconds(),
                    now.getMilliseconds()
                );
                this.Form.transactionData.transactionDate = new Date(currentTimeDate);
            }
        },

        fn_hasPendingItems: function(){
            let pendingItem = false;
            for(let i=0; i<this.Form.items.length; i++){
                if(this.Form.items[i].baseTransactionNumber && this.Form.items[i].baseTransactionNumber != this.Form.transactionData.mergeTransactionNumber){
                    pendingItem = true;
                    break;
                }
            }
            return pendingItem;
        },

        // fn_updateTaxCategories: function(itemIndex){
        //     this.fn_getProductData(itemIndex);
        // },

        fn_getProductData: function (index) {
            this.snackbarTaxCategory = false;
            let itemIndex = index ? index : 0;
            let productId = this.Form.items[itemIndex].productId;
			let self = this; 
			this.getData('Product', productId, 
				{
					onSuccess: function(response){
			          	console.log(response);
			          	let productData = JSON.parse(response);
                        if(self.fn_isNewTaxForm()){
                            self.Form.items[itemIndex].taxValue = productData.newTaxValue;
                            self.Form.items[itemIndex].cessValue = productData.newCessValue;
                            self.Form.items[itemIndex].cessValueOnQuantity = productData.newCessValueOnQuantity ? productData.newCessValueOnQuantity : null;
                            self.Form.items[itemIndex].taxCategoryId = productData.newTaxCategoryId;
                            self.Form.items[itemIndex].taxCategoryName = productData.newTaxCategoryName;
                            //saving default tax value for draft
                            self.Form.items[itemIndex].defaultTaxCategoryId = productData.newTaxCategoryId;
                            self.Form.items[itemIndex].defaultTaxValue = productData.newTaxValue;
                            self.Form.items[itemIndex].defaultCessValue = productData.newCessValue;

                            self.Form.items[itemIndex].isCessApplicable = productData.newCessValue || productData.newCessValueOnQuantity ? true : false;
                        }
                        else{
                            self.Form.items[itemIndex].taxValue = productData.taxValue;
                            self.Form.items[itemIndex].cessValue = productData.cessValue;
                            self.Form.items[itemIndex].cessValueOnQuantity = productData.cessValueOnQuantity ? productData.cessValueOnQuantity : null;
                            self.Form.items[itemIndex].taxCategoryId = productData.taxCategoryId;
                            self.Form.items[itemIndex].taxCategoryName = productData.taxCategoryName;
                            self.Form.items[itemIndex].defaultTaxCategoryId = productData.taxCategoryId;
                            self.Form.items[itemIndex].defaultTaxValue = productData.taxValue;
                            self.Form.items[itemIndex].defaultCessValue = productData.cessValue;

                            self.Form.items[itemIndex].isCessApplicable = productData.cessValue || productData.cessValueOnQuantity ? true : false;
                        }

                        if(itemIndex < (self.Form.items.length - 1)){
                            self.fn_getProductData(itemIndex + 1);
                        }
                        else{
                            self.fn_calculateTax();
                        }
			        }, 
			        onError: function(error){
			          	console.log(error);
			        }
				}
	        );
		},

        fn_changeDateAndBindTransactionNumber: function(value){
            this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(value);
            this.fn_bindTransactionNumber();
            this.fn_closeDialog();
        },

        fn_dueDate: function(billDate, transactionDate, days){
            let date = billDate ? billDate : transactionDate;
            let result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        },

        fn_getLastTransactionDate: function(transactionListId, callback){
            let filterObject = {};
            filterObject.transactionListId = [transactionListId];
            this.getFilterData('LastTransactionDateByType', null, filterObject,
                {
                    onSuccess: function(response){
                    console.log(response);
                    callback ? callback(JSON.parse(response)) : '';
                },
                    onError: function(error){
                    console.log(error);
                }
            });
        },

        fn_balanceLabel: function(partyDetails){
            if(partyDetails.groupTypeId == 103){
                if(partyDetails.balance < 0){
                    return "Credit"
                }
                else{
                    return "Debit"
                }
            }
            else{
                if(partyDetails.balance < 0){
                    return "To Pay"
                }
                else{
                    return "To Receive"
                }
            }
        },

        fn_differenceOfDays: function(){
            let businessCreatedDays = new Date(this.$root.CurrentBusiness.CreatedOn);
            let dateNow = new Date();
            return parseInt((dateNow - businessCreatedDays) / (1000 * 60 * 60 * 24), 10); 
        },

        fn_checkDate: function(batch){
            let date = this.$moment(new Date()).startOf('day');
            let eDate = this.$moment(new Date(batch.expDate)).startOf('day');
            if(date > eDate){
                return true;
            }
            else{
                return false;
            }
        },

        fn_getDate: function(batch){
            let dt = this.$moment(batch.expDate).endOf('day');
            let value = this.$moment(dt).from(new Date());
            if(value.indexOf('hours ago') != -1){
                return 'a day ago';
            }
            else{
                return value;
            }
        },

        fn_openAddressDialog: function(addressObj){
            this.Form.addressData = JSON.parse(JSON.stringify(addressObj));
            this.fn_openDialogWeb('web', 'DialogAddress', 'ref_dialogAddress');
        },

        fn_openSelectAddressDialog: function(){
            this.fn_openDialogWeb('web', 'DialogSelectAddress', 'ref_dialogSelectAddress');
        },

        fn_openCountryDialog: function (platform, name, ref, countryId, country) {

            var tagId = this.guidWeb();

            var dialogObj = {};
            dialogObj.tagId = tagId;
            dialogObj.formId = this.formId;
            dialogObj.name = name;
            dialogObj.ref = ref;
            //dialogObj.data = null;
            dialogObj.platform = platform;

            var viewDialogObject = {};
            viewDialogObject.ToolbarTitle = "Select Country";
            viewDialogObject.TopMenu = [menuItem.new];
            viewDialogObject.isBottomMenu = false;

            var paramObject = {};
            paramObject.defaultValue = {"id":null, "name":null};

            if(countryId && country){
                paramObject.defaultValue = {"id":countryId, "name":country};
            }

            dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'country', tagId, paramObject, ref);
        },

        fn_updateCountry: function (selectedValueId, selectedValueName, isRemoved) {
            if(!isRemoved){
                this.Form.addressData.countryId = selectedValueId;
                this.Form.addressData.country = selectedValueName;
                this.Form.addressData.stateId = null;
                this.Form.addressData.state = null;
                selectedValueName != 'India' ? this.fn_getOtherStates(selectedValueName) : '';
            }
            else{
                this.Form.addressData.countryId = null;
                this.Form.addressData.country = null;
            }
        },

        fn_getOtherStates: function(country){
            let filterObject = {};
            filterObject.country = country;

            let self = this;
            this.getFilterData('OtherStates', null, filterObject, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        if(response){
                            self.Form.addressData.otherStates = JSON.parse(response);
                        }
                        else{
                            self.Form.addressData.otherStates = [];
                        }
                    }, 
                    onError: function(error){
                      console.log(error);
                    }
                }
            );
        },

        fn_openOtherStates: function(country){
            let filterObject = {};
            filterObject.country = country;

            let self = this;
            this.getFilterData('OtherStates', null, filterObject, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        if(response){
                            self.Form.otherStates = JSON.parse(response);
                        }
                        else{
                            self.Form.otherStates = [];
                        }
                    }, 
                    onError: function(error){
                      console.log(error);
                    }
                }
            );
        },

        fn_openAddressStates: function (platform, name, ref) {

            var tagId = this.guidWeb();

            var dialogObj = {};
            dialogObj.tagId = tagId;
            dialogObj.formId = this.formId;
            dialogObj.name = name;
            dialogObj.ref = ref;
            //dialogObj.data = null;
            dialogObj.platform = platform;

            var viewDialogObject = {};
            viewDialogObject.ToolbarTitle = "Select State";
            viewDialogObject.TopMenu = [menuItem.new];
            viewDialogObject.isBottomMenu = false;

            var paramObject = {};
            paramObject.defaultValue = {"id":null, "name":null};

            if(this.Form.addressData.stateId && this.Form.addressData.state){
                paramObject.defaultValue = {"id":this.Form.addressData.stateId, "name":this.Form.addressData.state};
            }

            dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'state', tagId, paramObject, ref);
        },

        fn_updateAddressState: function (selectedValueId, selectedValueName, isRemoved) {
            if(!isRemoved){
                this.$set(this.Form.addressData, 'stateId', selectedValueId);
                this.$set(this.Form.addressData, 'state', selectedValueName);
                // this.Form.addressData.stateId = selectedValueId;
                // this.Form.addressData.state = selectedValueName;
            }
            else{
                this.Form.addressData.stateId = null;
                this.Form.addressData.state = null;
            }
            this.$forceUpdate();
        },

        fn_saveAddress: function(addressObj){
            if(!this.Form.addresses || !this.Form.addresses.length){
                this.Form.addresses = [];
            }
            
            // let itemIndex = this.Form.addresses.findIndex(address=>{return address.addressId == addressObj.addressId});
            let itemIndex = this.Form.addresses.findIndex(address=>{return address.groupTypeId == addressObj.groupTypeId});
            if(itemIndex != -1){
                this.Form.addresses[itemIndex] = JSON.parse(JSON.stringify(addressObj));
            }
            else{
                this.Form.addresses.push(JSON.parse(JSON.stringify(addressObj)));
            }

            if(this.Form.partyDetails){
                let itemPartyIndex = this.Form.partyDetails.addresses.findIndex(address=>{return address.addressId == addressObj.addressId});
                if(itemPartyIndex != -1){
                    this.Form.partyDetails.addresses[itemPartyIndex] = JSON.parse(JSON.stringify(addressObj));
                }
                else{
                    this.Form.partyDetails.addresses.push(JSON.parse(JSON.stringify(addressObj)));
                }
            }
            
            
            this.fn_closeDialog();
        },

        // fn_isMultiShipAddress: function(){
        //     if(this.Form.partyDetails && this.Form.partyDetails.addresses){
        //         let shippingAddresses = this.Form.partyDetails.addresses.filter(address=>{
        //             return address.groupTypeId == 102;
        //         })
        //         if(shippingAddresses && shippingAddresses.length && shippingAddresses.length > 1){
        //             return true;
        //         }
        //         else{
        //             return false;
        //         }
        //     }
        //     else{
        //         return false;
        //     }
        // },

        fn_getItemDetailFields: function(typeFormId){
            let self = this;
            this.getData('GetTransactionTypeSection', typeFormId, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.Form.itemSectionAndFields = JSON.parse(response);
                        // if(!self.Form.itemSectionAndFields || (self.Form.itemSectionAndFields && (!self.Form.itemSectionAndFields.transactionSections || !self.Form.itemSectionAndFields.transactionSections.length))){
                        //     self.fn_postItemDetailSection(typeFormId);
                        // }
                        // else{
                        if(self.Form.itemSectionAndFields && self.Form.itemSectionAndFields.transactionSections.length){
                            self.Form.dynamicItemSection = [];
                            self.Form.itemSectionAndFields.transactionSections.forEach(function (item) {
                                let obj = {};
                                obj.MenuID = null;
                                obj.Icon = null;
                                obj.Text = item.sectionName;
                                obj.Action = 'section_'+item.sectionId;
                                obj.sectionId = item.sectionId;
                                obj.hideOption = false;
                                self.Form.dynamicItemSection.push(obj);
                            });
                        }
                        // }
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        // fn_postItemDetailSection: function(typeFormId){
        //     let dataObj = {};
        //     dataObj.sectionId = this.guid();
        //     dataObj.sectionName = "Item Details";
        //     dataObj.orderNumber = 1;
        //     dataObj.isHidden = false;
        //     dataObj.transactionTypeFormId = typeFormId;
        //     dataObj.isSystem = 1;
        //     dataObj.sectionType = 1; //1 is for item section 
        //     let self = this;
        //     this.postData('PostTransactionTypeSection', dataObj, 
		// 		{
		// 			onSuccess: function(response){
		// 				console.log(response);
		// 				self.fn_getItemDetailFields(typeFormId);
		// 			},
		// 			onError: function(error){
		// 				console.log(error);
		// 			}
		// 		}
		// 	)
        // },

        fn_bindDynamicItemFields: function (sectionId) {

            this.Form.dynamicFields = {"section":null, "items":[], "additionalData":{}, "accountGroupId":null, "accountGroupName":null, "isItemDetails":true};

            // let itemIndex = this.Form.productData.items[0].customFields.findIndex(item=>{
            //     return item.section.sectionId == sectionId;
            // });
            let customFields = [];
            if(this.settings.transactionTypeId == 10001 || this.settings.transactionTypeId == 10002 || this.settings.transactionTypeId == 10003 || this.settings.transactionTypeId == 10004 || this.settings.transactionTypeId == 10005){
                customFields = this.Form.productData.items[0].customFields;
            }
            else{
                customFields = this.Form.productDataModel.customFields;
            }

            let itemIndex = customFields.findIndex(item=>{
                return item.section.sectionId == sectionId;
            });

            this.Form.dynamicFields.section = this.Form.itemSectionAndFields.transactionSections.find(item=>{
                return sectionId == item.sectionId;
            });

             if(this.Form.itemSectionAndFields && this.Form.itemSectionAndFields.transactionTypeFields && this.Form.itemSectionAndFields.transactionTypeFields.length){
                this.Form.dynamicFields.items = this.Form.itemSectionAndFields.transactionTypeFields.filter(item=>{
                    if(sectionId == item.sectionId){
                        item.additionalData = typeof(item.additionalData) == 'string' ? JSON.parse(item.additionalData) : item.additionalData;
                        item.value = null;
                        item.listItemId = null;
                        item.accountLedgerId = null;

                        if(item.fieldType == 'yes/no'){
                            item.value = item.additionalData.defaultValue;
                        }

                        if(item.fieldType == 'choice'){
                            item.value = item.additionalData.defaultChoice;
                        }
                        
                        return true;
                    }
                });
            }
            

            if(itemIndex!=-1){

                for(let i=0; i<this.Form.dynamicFields.items.length; i++){

                    let defaultField = this.Form.dynamicFields.items[i];

                    // for(let j=0; j<this.Form.productData.items[0].customFields[itemIndex].items.length; j++){
                    for(let j=0; j<customFields[itemIndex].items.length; j++){

                        // let existingField = this.Form.productData.items[0].customFields[itemIndex].items[j];
                        let existingField = customFields[itemIndex].items[j];

                        if(defaultField.fieldId == existingField.fieldId){
                            defaultField.value = existingField.value;

                            if(defaultField.fieldType == 'linkedItem'){
                                defaultField.listItemId = existingField.listItemId;
                            }
                            else if(defaultField.fieldType == 'accountItem'){
                                defaultField.accountLedgerId = existingField.accountLedgerId;
                            }

                        }

                    }

                }

            }
            

            console.log(JSON.stringify(this.Form.dynamicFields));

            this.fn_saveItemFields(this.Form.dynamicFields);

            // this.fn_openDialogDynamicFields();
        },

        fn_saveItemFields: function (fieldsObj) {
            let data = JSON.parse(JSON.stringify(fieldsObj));

            console.log(JSON.stringify(data));

            //finding if details already exist
            // let itemIndex = this.Form.productData.items[0].customFields.findIndex(item=>{
            //     return item.section.sectionId == data.section.sectionId;
            // })

            // this.Form.productData.items[0].customFields = data;
            if(this.settings.transactionTypeId == 10001 || this.settings.transactionTypeId == 10002 || this.settings.transactionTypeId == 10003 || this.settings.transactionTypeId == 10004 || this.settings.transactionTypeId == 10005){
                this.Form.productData.items[0].customFields = data;
            }
            else{
                this.Form.productDataModel.customFields = data;
            }

            // if(itemIndex==-1){
            //     this.Form.productData.items[0].customFields.push(data);
            // }
            // else{
            //     this.Form.productData.items[0].customFields[itemIndex] = data;
            //     this.$forceUpdate();
            // }

            console.log(JSON.stringify(this.Form.productData.items[0].customFields));

            // this.fn_closeDialog();
        },

        fn_removeItemFields: function (index) {
            this.Form.productData.items[0].customFields.splice(index, 1);
        },

        fn_openDialogPaymentModeSelection: function(type){
            this.Form.paymentModeType = type;
            setTimeout(() => {
                this.fn_openDialogWeb('web', 'PaymentModeSelection', 'ref_dialogPaymentModeSelection');
            }, 100);
        },

        fn_savePaymentMode: function(selectedItem, type, closeDialog){
            if(!this.Form.dutiesAndTaxesLedgers){
                this.Form.dutiesAndTaxesLedgers = [];
            }

            if(!this.Form.otherLedgers){
                this.Form.otherLedgers = [];
            }

            // checking if selected account already under payment groups
            let alreadyExist = false;
            for(let i=0; i<this.Form.paymentGroups.length; i++){
                for(let j=0; j<this.Form.paymentGroups[i].accountLedgers.length; j++){
                    if(this.Form.paymentGroups[i].accountLedgers[j].accountLedgerId == selectedItem.accountLedgerId){
                        alreadyExist = true;
                    }
                }   
            }

            if(type == 'duties_and_taxes'){
                let itemIndex = this.Form.dutiesAndTaxesLedgers.findIndex(ledger=>{
                    return ledger.accountLedgerId == selectedItem.accountLedgerId;
                })
                if(itemIndex == -1){
                    this.Form.paymentLedgerId = selectedItem.accountLedgerId;
                    if(!alreadyExist){
                        this.Form.dutiesAndTaxesLedgers.push(selectedItem);
                    }
                }
            }
            else{
                let itemIndex = this.Form.otherLedgers.findIndex(ledger=>{
                    return ledger.accountLedgerId == selectedItem.accountLedgerId;
                })
                if(itemIndex == -1){
                    this.Form.paymentLedgerId = selectedItem.accountLedgerId;
                    if(!alreadyExist){
                        this.Form.otherLedgers.push(selectedItem);
                    }
                }
            }
            
            closeDialog ? this.fn_closeDialog() : '';
        },

        fn_getTotalQty: function(displayView){
            let isSimilarUnit = true;
            let unitId = null;
            let qty = 0;
            let items = displayView ? this.displayData.transactionProducts : this.Form.items;
            
            for(let i=0; i<items.length; i++){
                if(unitId){
                    if(items[i].productVariants[0].selectedUnit && unitId != items[i].productVariants[0].selectedUnit.itemId){
                        isSimilarUnit = false;
                        break;    
                    }
                    else if(unitId != items[i].productVariants[0].unitId){
                        isSimilarUnit = false;
                        break;    
                    }
                }
                
                if(items[i].productVariants[0].selectedUnit){
                    unitId = items[i].productVariants[0].selectedUnit.itemId;
                    qty = qty = qty + Number(items[i].productVariants[0].qty);
                }
                else if(items[i].productVariants[0].unitId){
                    unitId = items[i].productVariants[0].unitId;
                    qty = qty = qty + Number(items[i].productVariants[0].qty);
                }
            }
            if(isSimilarUnit && qty){
                return this.roundUpto2Decimals(qty);
            }
            else{
                return 0;
            }
        },

        fn_isNewTaxForm: function(){
            // if(new Date(this.Form.transactionData.transactionDate) >= new Date('09/22/2024')){
            let tDay = new Date(this.Form.transactionData.transactionDate).getDate();
            let tMonth = new Date(this.Form.transactionData.transactionDate).getMonth() + 1;
            let tYear = new Date(this.Form.transactionData.transactionDate).getFullYear();
            if(new Date(tMonth + '/' + tDay + '/' + tYear) >= new Date('09/22/2025')){
                return true;
            }
            else{
                return false;
            }
        },

        fn_addDiscountToAll: function(addon){
            this.selectedAddOn = addon;
            this.fn_openDialogWeb('web', 'DiscountWhole', 'ref_dialogDiscountWhole');
        },

        fn_getDiscountPercentage: function(item){
            let isSimilarDiscount = true;
            let percent = null;
            for(let i=0; i<this.Form.items.length; i++){
                let addOn = this.Form.items[i].addOnsItems.filter(addon=>{
                    return addon.addOnsId == item.addOnsId;
                });

                if(addOn && addOn.length){
                    if(percent != null && percent != addOn[0].percentage){
                        isSimilarDiscount = false;
                        // break;
                    }
                    else{
                        percent = addOn[0].percentage;
                    }
                }
                else{
                    isSimilarDiscount = false;
                }
            }
            if(percent != null && percent != undefined && isSimilarDiscount)
                return '@'+ percent + '%';
            else
                return '';
        },

        fn_getDiscountPercentageDisplayView: function(item){
            let isSimilarDiscount = true;
            let percent = null;
            
            for(let i=0; i<this.displayData.transactionProducts.length; i++){
                let addOn = this.displayData.transactionProducts[i].transactionProductAddOns.filter(addon=>{
                    return addon.addOnsId == item.addOnsId;
                });

                if(addOn && addOn.length){
                    if(percent != null && percent != addOn[0].percentage){
                        isSimilarDiscount = false;
                        break;
                    }
                    else{
                        percent = addOn[0].percentage;
                    }
                }
                else{
                    isSimilarDiscount = false;
                }
            }
            if(percent != null && percent != undefined && isSimilarDiscount)
                return '@'+ percent + '%';
            else
                return '';
        },

        fn_isAddonCommon: function(addOnsId) {
            let percentage = null;

            if(this.Form.items && this.Form.items.length){
                for (const item of this.Form.items) {
                    const addon = item.addOnsItems.find(a => a.addOnsId === addOnsId);

                    // addon missing in any item → false
                    if (!addon) return false;

                    // first occurrence
                    if (percentage === null) {
                        percentage = addon.percentage;
                    } 
                    // percentage mismatch → false
                    else if (percentage !== addon.percentage) {
                        return false;
                    }
                }
            }
        
            return true;
        },


        fn_openGodowns: function(platform, name, ref, godownId, godownName, action){
            var tagId = this.guidWeb();

            var dialogObj = {};
            dialogObj.tagId = tagId;
            dialogObj.formId = this.formId;
            dialogObj.name = name;
            dialogObj.ref = ref;
            //dialogObj.data = null;
            dialogObj.platform = platform;


            var self = this;

            var viewDialogObject = {};
            viewDialogObject.ToolbarTitle = "Select Godown";

            let menuAction = action ? action : 'newgodown';

            let menuItemCustom = {"MenuID":1, "Icon":null, "Text":"New", "Action":menuAction};
            viewDialogObject.TopMenu = [menuItemCustom];
            // viewDialogObject.hideChip = true;
            
            var paramObject = {};
            paramObject.defaultValue = {"id":godownId, "name":godownName};

            dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'godown', tagId, paramObject, ref);	
        },

        fn_newGodown: function(){
            this.$router.push({path:'/masters/inventory/godown/items/new', query:{tagId:this.guidWeb(), ls:1}});
        },

        fn_updateGodown: function (selectedValueId, selectedValueName, isRemoved) {
            if(!isRemoved){
                this.Form.godownId = selectedValueId;
                this.Form.godownName = selectedValueName;
            }
            else{
                this.Form.godownId = null;
                this.Form.godownName = null;
            }
        },

    },
    mounted: function(){
        this.$validator.extend('verify_hsn', {
            validate: value => {
                // return regpan.test(value);
                if(value.length == 4 || value.length == 6 || value.length == 8){
                    return true;
                }
                else{
                    return false;
                }
            }
        });

        // window.js_globals.fn_openPermissionDialog = this.fn_openPermissionDialog;
    }
}


// WEBPACK FOOTER //
// ./src/components/transactions/transaction_mixin.js